import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import { openWhatsApp, openTelegram } from '../../utils/contactHelpers';

const RelationshipImprovementWebinarPage = () => {
  const handleTelegramRegistration = () => {
    openTelegram();
    // Note: Telegram bot should be configured to handle webinar registration messages
  };

  const handleWhatsAppRegistration = () => {
    openWhatsApp('Здравствуйте! Запишите меня, пожалуйста, на вебинар по улучшению отношений в паре');
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-foreground text-background py-4 sticky top-0 z-50 shadow-md">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <Icon name="ArrowLeft" size={24} />
            <span className="text-sm font-medium">Назад на главную</span>
          </Link>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Heart" size={20} color="white" />
            </div>
            <span className="font-bold">AI Dating</span>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <div className="w-20 h-20 bg-pink-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="Heart" size={40} color="white" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            Вебинар: Улучшение отношений
          </h1>
          <p className="text-xl text-foreground/70 max-w-3xl mx-auto">
            Современные методы укрепления пары: снижение конфликтов и углубление близости
          </p>
        </div>

        {/* Webinar Image */}
        <div className="mb-16">
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_1aedf42c5-1769875213486.png"
            alt="Счастливая пара на консультации у семейного психолога"
            className="w-full h-96 object-cover rounded-2xl shadow-xl" />

        </div>

        {/* Registration Buttons */}
        <div className="bg-gradient-to-r from-pink-50 to-pink-100 rounded-2xl p-8 mb-16">
          <h2 className="text-2xl font-bold text-foreground text-center mb-6">
            Записаться на вебинар
          </h2>
          <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
            <button
              onClick={handleTelegramRegistration}
              className="flex items-center justify-center gap-3 bg-blue-500 hover:bg-blue-600 text-white py-4 px-6 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg">

              <Icon name="Send" size={24} />
              <span>Записаться через Telegram</span>
            </button>
            <button
              onClick={handleWhatsAppRegistration}
              className="flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white py-4 px-6 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg">

              <Icon name="MessageCircle" size={24} />
              <span>Записаться через WhatsApp</span>
            </button>
          </div>
        </div>

        {/* Specialist Section */}
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-3xl font-bold text-foreground mb-6">
              Семейные психологи
            </h2>
            <div className="space-y-4 text-foreground/80">
              <p>
                Вебинар проводят сертифицированные семейные психологи, специализирующиеся на работе с парами и долгосрочными отношениями.
              </p>
              <div className="bg-white p-6 rounded-xl shadow-md">
                <h3 className="font-semibold text-foreground mb-3">Экспертиза специалистов:</h3>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={20} className="text-pink-500 mt-0.5" />
                    <span>Сертификация в парной терапии</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={20} className="text-pink-500 mt-0.5" />
                    <span>Специализация в разрешении конфликтов</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={20} className="text-pink-500 mt-0.5" />
                    <span>Опыт работы с более чем 500 парами</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={20} className="text-pink-500 mt-0.5" />
                    <span>Исследования устойчивости отношений</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Webinar Program */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-foreground text-center mb-12">
            Программа вебинара
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 bg-pink-500 rounded-lg flex items-center justify-center mb-4">
                <Icon name="MessageSquare" size={24} color="white" />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">
                Техники улучшения коммуникации
              </h3>
              <p className="text-foreground/70">
                Эффективные методы общения в паре. Как говорить о сложном без конфликтов. Активное слушание и эмпатия в отношениях.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 bg-pink-500 rounded-lg flex items-center justify-center mb-4">
                <Icon name="Shield" size={24} color="white" />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">
                Стратегии разрешения конфликтов
              </h3>
              <p className="text-foreground/70">
                Современные подходы к управлению разногласиями. Как превратить конфликт в возможность для роста. Техники деэскалации напряжения.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 bg-pink-500 rounded-lg flex items-center justify-center mb-4">
                <Icon name="Heart" size={24} color="white" />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">
                Углубление эмоциональной близости
              </h3>
              <p className="text-foreground/70">
                Практики для укрепления эмоциональной связи. Развитие эмоционального интеллекта в паре. Создание безопасного пространства для уязвимости.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="w-12 h-12 bg-pink-500 rounded-lg flex items-center justify-center mb-4">
                <Icon name="Users" size={24} color="white" />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">
                Работа с личными вопросами
              </h3>
              <p className="text-foreground/70">
                Индивидуальные консультации для пар. Разбор конкретных ситуаций участников. Персональные рекомендации от экспертов.
              </p>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="bg-gradient-to-br from-pink-50 to-pink-100 rounded-2xl p-12 mb-16">
          <h2 className="text-3xl font-bold text-foreground text-center mb-8">
            Результаты вебинара
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="TrendingUp" size={28} color="white" />
              </div>
              <h3 className="font-semibold text-foreground mb-2">Меньше конфликтов</h3>
              <p className="text-foreground/70 text-sm">
                Снижение частоты и интенсивности ссор
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Smile" size={28} color="white" />
              </div>
              <h3 className="font-semibold text-foreground mb-2">Больше понимания</h3>
              <p className="text-foreground/70 text-sm">
                Глубокое взаимопонимание и эмпатия
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Sparkles" size={28} color="white" />
              </div>
              <h3 className="font-semibold text-foreground mb-2">Крепче связь</h3>
              <p className="text-foreground/70 text-sm">
                Укрепление эмоциональной и физической близости
              </p>
            </div>
          </div>
        </div>

        {/* For Couples Section */}
        <div className="bg-white rounded-2xl p-12 mb-16 shadow-lg">
          <div className="max-w-3xl mx-auto text-center">
            <Icon name="Users" size={48} className="text-pink-500 mx-auto mb-6" />
            <h2 className="text-3xl font-bold text-foreground mb-4">
              Для пар и индивидуальных участников
            </h2>
            <p className="text-foreground/70 text-lg mb-6">
              Вебинар подходит как для пар, которые хотят улучшить отношения вместе, так и для тех, кто хочет работать над отношениями индивидуально.
            </p>
            <div className="grid md:grid-cols-2 gap-6 text-left">
              <div className="bg-pink-50 p-6 rounded-xl">
                <h3 className="font-semibold text-foreground mb-3">Для пар:</h3>
                <ul className="space-y-2 text-foreground/70 text-sm">
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={16} className="text-pink-500 mt-1" />
                    <span>Совместная работа над отношениями</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={16} className="text-pink-500 mt-1" />
                    <span>Парные упражнения и практики</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={16} className="text-pink-500 mt-1" />
                    <span>Возможность задать вопросы вдвоём</span>
                  </li>
                </ul>
              </div>
              <div className="bg-pink-50 p-6 rounded-xl">
                <h3 className="font-semibold text-foreground mb-3">Индивидуально:</h3>
                <ul className="space-y-2 text-foreground/70 text-sm">
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={16} className="text-pink-500 mt-1" />
                    <span>Работа над собой в отношениях</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={16} className="text-pink-500 mt-1" />
                    <span>Понимание своих паттернов поведения</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Icon name="Check" size={16} className="text-pink-500 mt-1" />
                    <span>Инструменты для улучшения динамики</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="bg-gradient-to-r from-pink-500 to-pink-600 rounded-2xl p-12 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">
            Укрепите свои отношения
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Запишитесь на вебинар и начните путь к гармоничным отношениям
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={handleTelegramRegistration}
              className="flex items-center justify-center gap-3 bg-white text-blue-600 hover:bg-blue-50 py-4 px-8 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg">

              <Icon name="Send" size={24} />
              <span>Telegram</span>
            </button>
            <button
              onClick={handleWhatsAppRegistration}
              className="flex items-center justify-center gap-3 bg-white text-green-600 hover:bg-green-50 py-4 px-8 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg">

              <Icon name="MessageCircle" size={24} />
              <span>WhatsApp</span>
            </button>
          </div>
        </div>
      </main>

      {/* Back to Top Button */}
      <div className="fixed bottom-8 right-8">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="bg-pink-500 text-white p-4 rounded-full shadow-lg hover:bg-pink-600 transition-all hover:scale-110"
          aria-label="Вернуться наверх">

          <Icon name="ArrowUp" size={24} />
        </button>
      </div>
    </div>);

};

export default RelationshipImprovementWebinarPage;